export class GabbySettingsModel {
	offline_message: string;
	offline_message_enabled: boolean;
}
